module.exports = __webpack_public_path__ + "static/media/icon-AMS.62030aa6.svg";